import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { Button } from '@/components/ui/button';
import { WORKSPACE_CLOSURE_GRACE_DAYS } from '@/constants/workspaceData';
import { useOrganizationQuery } from '@/hooks/useOrganization';
import { ScheduleClosureDialog } from './ScheduleClosureDialog';

const CONSEQUENCE_MESSAGE_KEYS = [
  'closure.consequences.intro',
  'closure.consequences.schedule',
  'closure.consequences.export',
  'closure.consequences.irreversible',
] as const;

export function UnscheduledClosurePanel() {
  const { t } = useTranslation('workspaceData');
  const organizationQuery = useOrganizationQuery(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function renderAction() {
    if (organizationQuery.isLoading === true) {
      return <LoadingSpinner className="w-5 h-5" />;
    }
    if (organizationQuery.isError === true || organizationQuery.data === undefined) {
      return (
        <QueryErrorState
          onRetry={function retry() {
            organizationQuery.refetch();
          }}
        />
      );
    }
    return (
      <>
        <Button
          variant="destructive"
          onClick={function openDialog() {
            setIsDialogOpen(true);
          }}
        >
          {t('closure.open')}
        </Button>
        {isDialogOpen ? (
          <ScheduleClosureDialog
            workspaceName={organizationQuery.data.name}
            onClose={function closeDialog() {
              setIsDialogOpen(false);
            }}
          />
        ) : null}
      </>
    );
  }

  return (
    <div className="space-y-4">
      <ul className="space-y-2 list-disc pl-5 max-w-3xl">
        {CONSEQUENCE_MESSAGE_KEYS.map(function renderConsequence(messageKey) {
          return (
            <li key={messageKey} className="text-[13px] text-zoomuted">
              {t(messageKey, { days: WORKSPACE_CLOSURE_GRACE_DAYS })}
            </li>
          );
        })}
      </ul>
      <div>{renderAction()}</div>
    </div>
  );
}
